import PortalPage from "@/components/PortalPage";

export default function DistributorPortal() {
  return (
    <PortalPage
      portal="DISTRIBUTOR"
      title="Run an entire region. Lead-to-cash in one tab."
      tagline="Multi-dealer ops, real-time logistics, credit-line workflows, and AI-ready regional BI — purpose-built for ceramic distributors."
      gradient="from-blue-700 via-indigo-900 to-black"
      heroBg="🌐"
      accentColor="from-blue-400 to-indigo-400"
      benefits={[
        { title: "Dealer-first CRM", body: "Onboard, score, segment dealers and assign credit lines in minutes." },
        { title: "Real-time logistics", body: "Track every truck, e-way bill and POD across your region." },
        { title: "Regional BI", body: "GST/PIN-wise dashboards, ageing reports and demand heatmaps." },
        { title: "Pricing & schemes", body: "Run zone-specific discount schemes — bundled with audit trail." },
        { title: "Vendor connect", body: "Send POs to multiple manufacturers from the same console." },
        { title: "Mobile-first", body: "Sales executives close orders from the field with offline-first apps." },
      ]}
      features={[
        "Multi-dealer onboarding with KYC vault",
        "Credit limit + ageing + collection workflows",
        "Region-wise BI dashboards",
        "GRN against PO with batch tracking",
        "Stripe + Razorpay collections",
        "e-way bill & POD capture",
        "Mobile sales executive app",
        "Configurable approval matrix",
        "Auto-generated GSTR reports",
        "WhatsApp order intake (Premium+)",
        "Branded dealer storefront",
        "Tally / SAP push (Enterprise)",
      ]}
      faqs={[
        { q: "Can I segment dealers by zone / city?", a: "Yes — unlimited zones, with per-zone pricing, schemes and credit lines." },
        { q: "What's the credit-line workflow?", a: "Set a per-dealer cap → block orders above cap → multi-level approval to release → auto-collection reminders." },
        { q: "Do you support multi-currency?", a: "Yes — Premium and Enterprise plans support multi-currency for cross-border distribution." },
        { q: "How does this compare to legacy DMS tools?", a: "Real-time, mobile-first, role-precise, and integrated with the manufacturer's ERP — no daily sync files." },
        { q: "Is there an API?", a: "Yes — REST + webhooks. Enterprise plan includes dedicated integration support." },
      ]}
    />
  );
}
